import { WeeklyMealSchedule } from '../../../uc-api-sdk';

export type ValidWeeklyMealScheduleDay = keyof Omit<WeeklyMealSchedule, '_id'>;

export class BGMonitoringScheduleHelper {
  public static readonly daysOrder: ValidWeeklyMealScheduleDay[] = [
    'mon', 'tues', 'wed', 'thurs', 'fri', 'sat', 'sun',
  ];
}
